import React, {useState} from 'react';
import PageLayout from '../layout/PageLayout';

export default function RegistrationPage() {
    const [form, setForm] = useState({
        country: '',
        email: '',
        full_name: '',
        organization: '',
        password: '',
        phone: '',
        purpose: '',
        username: ''
    });
    const [status, setStatus] = useState({error: '', loading: false, success: ''});

    const updateField = ev => {
        setForm({...form, [ev.target.name]: ev.target.value});
    };

    const submit = ev => {
        ev.preventDefault();
        setStatus({error: '', loading: true, success: ''});
        fetch('/fastapi/register', {
            body: JSON.stringify(form),
            headers: {'Content-Type': 'application/json'},
            method: 'POST'
        })
            .then(async response => {
                const data = await response.json().catch(() => ({}));
                if (!response.ok) {
                    throw new Error(data.detail || `Registration failed (${response.status})`);
                }
                return data;
            })
            .then(data => {
                setStatus({
                    error: '',
                    loading: false,
                    success: data.status === 'pending'
                        ? 'Access request submitted. An administrator must approve it before login.'
                        : 'Registration submitted.'
                });
                setForm({
                    country: '',
                    email: '',
                    full_name: '',
                    organization: '',
                    password: '',
                    phone: '',
                    purpose: '',
                    username: ''
                });
            })
            .catch(error => {
                setStatus({error: error.message, loading: false, success: ''});
            });
    };

    return (
        <PageLayout title="Request Access" kicker="Account">
            <p>
                Submit an account request for project participants and reviewers.
            </p>
            <form className="qwc-route-form qwc-route-form-wide" onSubmit={submit}>
                <label>
                    Username
                    <input autoComplete="username" name="username" onChange={updateField} required type="text" value={form.username}/>
                </label>
                <label>
                    Full name
                    <input autoComplete="name" name="full_name" onChange={updateField} required type="text" value={form.full_name}/>
                </label>
                <label>
                    Email
                    <input autoComplete="email" name="email" onChange={updateField} required type="email" value={form.email}/>
                </label>
                <label>
                    Password
                    <input autoComplete="new-password" minLength="8" name="password" onChange={updateField} required type="password" value={form.password}/>
                </label>
                <label>
                    Organization
                    <input autoComplete="organization" name="organization" onChange={updateField} type="text" value={form.organization}/>
                </label>
                <label>
                    Phone
                    <input autoComplete="tel" name="phone" onChange={updateField} type="tel" value={form.phone}/>
                </label>
                <label>
                    Country
                    <input autoComplete="country-name" name="country" onChange={updateField} type="text" value={form.country}/>
                </label>
                <label className="qwc-route-form-full">
                    Purpose
                    <textarea name="purpose" onChange={updateField} rows="4" value={form.purpose}/>
                </label>
                <button disabled={status.loading} type="submit">
                    {status.loading ? 'Submitting...' : 'Submit request'}
                </button>
                {status.success ? <div className="qwc-route-message qwc-route-message-success">{status.success}</div> : null}
                {status.error ? <div className="qwc-route-message qwc-route-message-error">{status.error}</div> : null}
            </form>
        </PageLayout>
    );
}
